import { render, staticRenderFns } from "./CompanyManageDetail.vue?vue&type=template&id=994728e2"
import script from "./CompanyManageDetail.vue?vue&type=script&lang=js"
export * from "./CompanyManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports